/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { SalesOrder, SalesOrdersDataActions } from '@msdyn365-commerce/retail-proxy';

/**
 * GetSalesOrderDetailBySalesid Input Action
 */
export class GetSalesOrderDetailBySalesIdInput implements Msdyn365.IActionInput {
    public salesId: string;
    constructor(salesId: string) {
        this.salesId = salesId;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `SALES-ORDER-DETAIL:${this.salesId}`;
    public getCacheObjectType = () => 'SALES-ORDER';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IGetSalesOrderDetailBySalesIdData {
    salesOrders: SalesOrder;
}

const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetSalesOrderDetailBySalesIdInput('');
};

async function action(input: GetSalesOrderDetailBySalesIdInput, ctx: Msdyn365.IActionContext): Promise<IGetSalesOrderDetailBySalesIdData> {
    return { salesOrders: await SalesOrdersDataActions.getSalesOrderDetailsBySalesIdAsync({ callerContext: ctx }, input.salesId || '') };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetSalesOrderDetailBySalesIdData>>action,
    id: 'GetSalesOrderDetailBySalesId',
    input: createInput
});
